import {
  TrendingUp,
  Landmark,
  Megaphone,
  Users,
  LayoutGrid,
  Scale,
  Briefcase,
  GraduationCap,
  Calculator,
  Gauge,
  UserCog,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "fractional-management",
    name: "Fractional Management",
    icon: UserCog,
    featured: true,
    points: ["Manager dedicato in azienda per tutta la durata del progetto", "Part-time o a progetto: paghi solo il tempo che serve", "Obiettivi, KPI e report condivisi ogni mese", "Profili finanza, marketing, HR e operations"],
    short: "Non hai chi ti segue? Ti affidiamo un manager per tutto il tempo del progetto.",
    home: "Non hai chi ti segue? Ti affidiamo un manager per tutto il tempo del progetto.",
    long:
      "Un manager Idea 360 entra nella tua azienda, part-time o a progetto, e guida l'area che oggi nessuno presidia: finanza, marketing, persone, operations. Non un consulente esterno, ma una persona che lavora con il tuo team ogni settimana, con obiettivi e KPI condivisi, fino al traguardo.",
  },
  {
    slug: "finanza",
    points: ["Budget e piano finanziario a 12-36 mesi", "Analisi e previsione del cash flow", "Valutazione investimenti e ritorno atteso", "Dossier per banche e investitori"],
    name: "Finanza",
    icon: TrendingUp,
    short: "Pianificazione finanziaria, cash flow e analisi di bilancio.",
    home: "Pianificazione finanziaria e supporto alle decisioni economiche.",
    long:
      "Strutturiamo la finanza aziendale con un approccio data-driven: budgeting, analisi del cash flow, valutazione degli investimenti e rapporto con banche e investitori. Decisioni rapide e fondate sui numeri.",
  },
  {
    slug: "controllo-di-gestione",
    points: ["Centri di costo e marginalità per prodotto e cliente", "Budget, consuntivi e analisi degli scostamenti", "Cruscotto KPI mensile condiviso", "Prezzi e listini basati sui costi reali"],
    name: "Controllo di Gestione",
    icon: Gauge,
    short: "KPI, marginalità e reportistica per decidere con i numeri.",
    home: "Monitoraggio dei numeri per decisioni consapevoli e tempestive.",
    long:
      "Costruiamo il sistema di controllo di gestione della tua impresa: centri di costo, analisi della marginalità per prodotto e cliente, budget e scostamenti, cruscotto KPI mensile. Sai sempre dove guadagni e dove perdi.",
  },
  {
    slug: "finanza-agevolata",
    points: ["Scouting bandi regionali, nazionali ed europei", "Verifica requisiti e pre-valutazione gratuita", "Redazione domanda e progetto", "Rendicontazione e gestione dell'iter fino all'erogazione"],
    name: "Finanza Agevolata",
    icon: Landmark,
    home: "Bandi, incentivi e finanziamenti pubblici per i tuoi progetti.",
    short: "Bandi, contributi regionali, PNRR e credito d'imposta.",
    long:
      "Individuiamo le opportunità di finanza agevolata più adatte al tuo progetto: bandi regionali, nazionali ed europei, PNRR, credito d'imposta R&S, Industria 4.0. Gestiamo l'intero iter, dalla candidatura alla rendicontazione.",
  },
  {
    slug: "marketing",
    points: ["Posizionamento e brand identity", "Strategia contenuti e piano editoriale", "Campagne advertising con budget misurato", "Funnel di acquisizione e reportistica"],
    name: "Marketing",
    icon: Megaphone,
    home: "Strategia, comunicazione e contenuti per far crescere il tuo brand.",
    short: "Strategia di brand, posizionamento e performance digitale.",
    long:
      "Definiamo il posizionamento e costruiamo un piano marketing orientato ai risultati: brand identity, content strategy, advertising e funnel di acquisizione. Misuriamo ogni euro investito.",
  },
  {
    slug: "hr",
    points: ["Ricerca e selezione del personale", "Valutazione delle performance", "Piani di sviluppo e formazione", "Cultura aziendale e clima interno"],
    name: "HR",
    icon: Users,
    home: "Selezione, gestione e sviluppo delle persone in azienda.",
    short: "Selezione, sviluppo e gestione delle persone.",
    long:
      "Supportiamo la tua azienda nella ricerca e selezione, nella valutazione delle performance, nei piani di sviluppo e nella costruzione di una cultura aziendale solida. Le persone sono il vero asset.",
  },
  {
    slug: "organizzazione",
    points: ["Organigramma e mansionari", "Mappatura e ottimizzazione dei processi", "Eliminazione colli di bottiglia", "Modelli operativi per la crescita"],
    name: "Organizzazione",
    icon: LayoutGrid,
    home: "Processi, ruoli e strutture che fanno funzionare l'impresa.",
    short: "Processi, ruoli e modelli operativi efficaci.",
    long:
      "Disegniamo organigrammi, mansionari e processi operativi che scalano con la tua attività. Eliminiamo colli di bottiglia e duplicazioni, valorizzando ruoli e responsabilità.",
  },
  {
    slug: "consulenza-legale",
    points: ["Contratti commerciali e con fornitori", "Diritto societario e patti tra soci", "Privacy e adeguamento GDPR", "Recupero crediti e gestione del contenzioso"],
    name: "Consulenza Legale",
    icon: Scale,
    home: "Supporto normativo e contrattuale per ogni fase del business.",
    short: "Contrattualistica, societario e tutela aziendale.",
    long:
      "Forniamo assistenza legale su contrattualistica commerciale, diritto societario, privacy GDPR, recupero crediti e gestione del contenzioso. Un partner stabile per ogni decisione critica.",
  },
  {
    slug: "consulenza-del-lavoro",
    points: ["Elaborazione buste paga e adempimenti", "Contratti di assunzione e inquadramenti", "Agevolazioni e bonus assunzioni", "Vertenze e relazioni sindacali"],
    name: "Consulenza del Lavoro",
    icon: Briefcase,
    home: "Contratti, buste paga e adempimenti in materia di lavoro.",
    short: "Buste paga, contratti e adempimenti normativi.",
    long:
      "Gestione completa del personale: elaborazione paghe, contrattualistica, adempimenti previdenziali e fiscali, gestione vertenze e relazioni sindacali. Conformità sempre garantita.",
  },
  {
    slug: "formazione",
    points: ["Percorsi tecnici e manageriali su misura", "Formazione finanziata con fondi interprofessionali", "Formazione regionale e voucher", "Erogazione in presenza e online"],
    name: "Formazione",
    icon: GraduationCap,
    home: "Percorsi formativi su misura per far crescere il team.",
    short: "Percorsi formativi su misura, anche finanziati.",
    long:
      "Progettiamo percorsi formativi tecnici e manageriali, in presenza e online, anche finanziati tramite fondi interprofessionali. Sviluppiamo competenze che generano valore.",
  },
  {
    slug: "contabilita",
    points: ["Tenuta contabile ordinaria e semplificata", "Bilanci e dichiarazioni fiscali", "Adempimenti telematici e scadenze", "Consulenza fiscale continuativa"],
    name: "Contabilità",
    icon: Calculator,
    home: "Tenuta contabile, bilanci e adempimenti fiscali sempre in ordine.",
    short: "Contabilità ordinaria, semplificata e fiscalità d'impresa.",
    long:
      "Tenuta della contabilità, dichiarazioni fiscali, bilanci e adempimenti telematici. Lavoriamo con strumenti digitali per darti visibilità sempre aggiornata sui numeri della tua attività.",
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
export const getServiceByName = (name) =>
  SERVICES.find((s) => s.name.toLowerCase() === (name || "").toLowerCase());
